
import { Options, Vue } from 'vue-class-component';
import AppTile from './AppTile.vue';
import api from '@/shared/api';
import getAppDefinitions, { AppDefinitions } from '@/shared/apps';
import session from "@/shared/session";

@Options({
    components: {
        AppTile,
    },
})
export default class AppStore extends Vue {
    protected installedApps: {
        subscribed: boolean;
        app_name: string}[] = [];
    protected allApps: AppDefinitions = {};

    protected ready = false;

    async openApp(appName: string) {
        const loggedIn = await session.checkSession();
        if (loggedIn) {
            this.$router.push({ name: 'apps-details', params: { appname: appName } });
        } else {
            this.$router.push({ name: 'public-apps-details', params: { appname: appName } });
        }
    }

    get availableApps() {
        // only show apps that have available = true
        return Object.fromEntries(Object.entries(this.allApps).filter(([name, app]) => app.available));
    }

    async created() {
        this.allApps = await getAppDefinitions();

        const loggedIn = await session.checkSession();
        if (loggedIn) {
            if (this.$route.name === 'public-apps-overview') {
                this.$router.push({name: 'apps-store-overview', params: {}})
                return;
            }

            const apps = await api.getInstalledApps();
            console.log('installedApps', apps);
            this.installedApps = apps;
        }

        this.ready = true;

        console.log('route', this.$route);
    }

    isInstalled(appName: string) {
        // Loop through installed apps and check if the app is installed
        return this.installedApps.some(app => app.app_name === appName);
    }
    isSubscribed(appName: string) {
        // Loop through installed apps and check if the app is installed
        return this.installedApps.some(app => app.app_name === appName && app.subscribed);
    }
}
